module.exports = __webpack_public_path__ + "img/1.cba28620.png";